import {
  Tooltip,
  TooltipTrigger,
  TooltipContent
} from "shared/components/Tooltip";
import { cx } from "shared/utils/classnames";
import {
  useClearConversationFlag,
  useUndoConversationFlagClear
} from "../api/hooks";
import { useInboxEmbed } from "../context/useInboxEmbed";
import type { ConversationFlagKind } from "../types";
import { CONTROL_TOOLTIP_CLASS } from "./controlPillStyles";
import { showUndoToast } from "../utils/undoToast";

const CLEAR_FLAG_TOOLTIP =
  "Handled this outside Boom? Clears the flag for everyone on your team.";

export const ClearFlagButton = ({
  conversationId,
  kind
}: {
  conversationId: string;
  kind: ConversationFlagKind;
}) => {
  const embed = useInboxEmbed();
  const { mutateAsync: clearFlag, isPending } =
    useClearConversationFlag(conversationId);
  const { mutate: undoClear } = useUndoConversationFlagClear(conversationId);

  const onClick = () =>
    clearFlag(kind)
      .then(({ clear }) =>
        showUndoToast("Flag cleared for everyone", () => undoClear(clear.id))
      )
      .catch(() => undefined);

  return (
    <Tooltip placement="bottom-end">
      <TooltipTrigger asChild>
        <button
          type="button"
          disabled={isPending}
          onClick={onClick}
          className="shrink-0 font-bold text-danger-700 hover:underline disabled:opacity-50"
        >
          Clear flag
        </button>
      </TooltipTrigger>
      <TooltipContent className={cx(CONTROL_TOOLTIP_CLASS, embed?.menuZClass)}>
        {CLEAR_FLAG_TOOLTIP}
      </TooltipContent>
    </Tooltip>
  );
};
